import {
  QuixxsCreditsResponse,
  QuixxsSessionCredentials,
  SettleQuixxsSessionResponse,
} from '../models'
import {assertBoolean, assertNumber, assertObject, assertString} from '../utils'
import {AssertTypeFn} from './general'

const quixxsRecordingPolicyNormaliser: AssertTypeFn<
  QuixxsSessionCredentials['recordingPolicy']
> = (obj) => ({
  balanceAtStartMinutes: assertNumber(obj.balanceAtStartMinutes),
  inSessionGraceMaxMinutes: assertNumber(obj.inSessionGraceMaxMinutes),
  maxRecordableMinutes: assertNumber(obj.maxRecordableMinutes),
})

export const quixxsSessionNormaliser: AssertTypeFn<QuixxsSessionCredentials> = (
  obj,
) => ({
  cushlaSessionId: assertString(obj.cushlaSessionId),
  token: assertString(obj.token),
  uuid: assertString(obj.uuid),
  visitId: assertNumber(obj.visitId),
  sessionId: assertNumber(obj.sessionId),
  patientId:
    obj.patientId === null || obj.patientId === undefined
      ? null
      : assertNumber(obj.patientId),
  recordingPolicy: assertObject(
    obj.recordingPolicy,
    quixxsRecordingPolicyNormaliser,
  ),
})

export const quixxsCreditsNormaliser: AssertTypeFn<QuixxsCreditsResponse> = (
  obj,
) => ({
  availableMinutes: assertNumber(obj.availableMinutes),
  availableFormatted: assertString(obj.availableFormatted),
  maxBalanceMinutes: assertNumber(obj.maxBalanceMinutes),
  monthlyAllowanceMinutes: assertNumber(obj.monthlyAllowanceMinutes),
  nextIssuanceAt: assertString(obj.nextIssuanceAt),
  canStartRecording: assertBoolean(obj.canStartRecording),
})

export const settleQuixxsSessionNormaliser: AssertTypeFn<
  SettleQuixxsSessionResponse
> = (obj) => ({
  availableMinutes: assertNumber(obj.availableMinutes),
  availableFormatted: assertString(obj.availableFormatted),
  creditsDepleted: assertBoolean(obj.creditsDepleted),
})
